import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';

const {
  formField: { principalType, principalSsn, principalIsUSCitizen },
} = loanFormModel;

export class PrincipalSsnValidation implements ValidationSchema {
  public name = principalSsn.name;
  public label = principalSsn.label;
  public dependsOn: string[] = [principalType.name, principalIsUSCitizen.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    principalType: string,
    principalIsUSCitizen: string,
    schema,
    context: any
  ) {
    const isPrincipal =
      context.parent.relationship == RELATED_PARTY_RELATIONSHIP.PRINCIPAL;
    if (!isPrincipal) return schema;
    if (
      principalType === RELATED_PARTY_TYPES.INDIVIDUAL &&
      principalIsUSCitizen === 'Yes'
    ) {
      return schema
        .required(principalSsn.requiredErrorMsg)
        .min(9, 'Social Security Number has 9 digits')
        .max(9, 'Social Security Number has 9 digits');
    }
    return schema.transform(() => null);
  }
}

export default new Validation(new PrincipalSsnValidation());
